import { render, staticRenderFns } from "./main-content-and-introduction.component.vue?vue&type=template&id=48eb0446"
import script from "./main-content-and-introduction.component?vue&type=script&lang=ts&external"
export * from "./main-content-and-introduction.component?vue&type=script&lang=ts&external"
import style0 from "./main-content-and-introduction.component.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports